import { useRef } from 'react';

/**
 * Verrou d'envoi, à poser AVANT le premier `await` d'un tour.
 *
 * L'invariant tient à deux choses, et manquer l'une des deux laisse passer un
 * doublon complet — deux appels au modèle, deux tours persistés, deux
 * `usage_records` :
 *
 * — le verrou est un **ref**, pas un state : deux clics dans le même tick lisent
 *   tous deux le rendu précédent, donc l'ancien `streaming`/`busy`, et un
 *   garde-fou d'état les laisse passer tous les deux ;
 * — il se lève **avant le téléversement**, pas à l'entrée du tour : c'est
 *   pendant l'upload que la fenêtre s'ouvre, et elle dure ce que dure l'envoi
 *   du fichier. Sans pièce jointe elle est nulle, ce qui explique que le défaut
 *   ne se voie qu'à l'import.
 */
export function useSendLock(): (turn: () => Promise<void>) => void {
  const inFlight = useRef(false);
  return (turn) => {
    if (inFlight.current) return;
    inFlight.current = true;
    /* Le tour est lance sans etre attendu : une exception qui en sortirait
       deviendrait un rejet non traite, invisible a l'ecran ET incapable de
       relacher le verrou — le composeur resterait mort jusqu'au rechargement.
       Les appelants affichent deja leurs propres erreurs ; ce filet ne rattrape
       qu'un defaut du corps du tour. */
    void turn()
      .catch((e: unknown) => console.error('[chat] envoi interrompu :', e))
      .finally(() => {
        inFlight.current = false;
      });
  };
}
